var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccreditedIcon = function SvgAccreditedIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D14339",
    d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.593 4H6.4v1.4l4.064 3.05a4.9 4.9 0 0 0 1.167 9.537 4.897 4.897 0 0 0 1.897-9.537l4.065-3.05zm-3.54 12.242-2.057-1.203-2.056 1.203.545-2.33-1.812-1.566 2.386-.203.937-2.197.938 2.197 2.385.203-1.812 1.567z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccreditedIcon);
export default ForwardRef;